import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Form } from 'react-bootstrap'
import { useStateValue } from '@State'

const NewExceptionExtendModal = props => {
  const [radioValue, setRadioValue] = useState(true)
  const [shiftDays, setShiftDays] = useState(0)
  const [shiftHours, setShiftHours] = useState(0)
  const [shiftMinutes, setShiftMinutes] = useState(0)
  const [, dispatch] = useStateValue()

  return (
    <Modal show={props.show} onHide={() => props.toggle(!props.show)}>
      <Modal.Header>
        <Modal.Title>Extend Due Dates</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <div>
            <label className="pt-4 pr-3 pb-4">
              <input
                name={props.name}
                type="radio"
                value={false}
                checked={!radioValue}
                onChange={() => {
                  setRadioValue(false)
                }}
              />
              &nbsp;Remove Due Dates
            </label>
          </div>
          <div>
            <label>
              <input
                name={props.name}
                type="radio"
                checked={radioValue}
                onChange={() => {
                  setRadioValue(true)
                }}
              />
              &nbsp;Shift Dates
            </label>
            {radioValue && (
              <div className="pt-3 pr-3 pl-4">
                Shift due dates forward by a number of days, hours, and/or
                minutes.
                <div>
                  <label htmlFor="shiftDaysInput" className="pt-3 pr-4 h5">
                    Days
                  </label>
                </div>
                <input
                  type="number"
                  className="form-control"
                  value={shiftDays}
                  id="shiftDaysInput"
                  min={0}
                  onChange={e => {
                    setShiftDays(e.currentTarget.value)
                  }}
                />
                <div>
                  <label htmlFor="shiftHoursInput" className="pt-3 pr-4 h5">
                    Hours
                  </label>
                </div>
                <input
                  type="number"
                  className="form-control"
                  value={shiftHours}
                  id="shiftHoursInput"
                  min={0}
                  onChange={e => {
                    setShiftHours(e.currentTarget.value)
                  }}
                />
                <div>
                  <label htmlFor="shiftMinutesInput" className="pt-3 pr-4 h5">
                    Minutes
                  </label>
                </div>
                <input
                  type="number"
                  className="form-control"
                  value={shiftMinutes}
                  id="shiftMinutesInput"
                  min={0}
                  onChange={e => {
                    setShiftMinutes(e.currentTarget.value)
                  }}
                />
              </div>
            )}
          </div>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        {shiftDays > 0 || shiftHours > 0 || shiftMinutes > 0 || !radioValue ? (
          <button
            onClick={() => {
              dispatch({
                type: 'updateExceptionType',
                exceptionType: 'extendDueDate',
                shiftDays: Number(shiftDays),
                shiftHours: Number(shiftHours),
                shiftMinutes: Number(shiftMinutes),
                override: !radioValue,
              })
              props.toggle(false)
            }}
            className="btn btn-myed btn-primary btn-primary-myed pull-right"
          >
            Ok
          </button>
        ) : (
          <button className="btn btn-myed btn-primary btn-primary-myed pull-right" disabled>
            Ok
          </button>
        )}
        <button
          onClick={() => {
            props.toggle(false)
          }}
          className="btn btn-myed btn-default btn-default-myed pull-right"
        >
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default NewExceptionExtendModal

NewExceptionExtendModal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  name: PropTypes.string,
}
